import React, { useEffect } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const Bienestarydesarrollo = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'> {/* container, container-full-width */}
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Apoyo Para el Bienestar y Desarrollo"</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                El Programa Estatal Apoyo para el Bienestar y el Desarrollo tiene su origen en las políticas públicas del Gobierno del Estado de Hidalgo orientadas a la reducción de la pobreza, la marginación y el rezago social, en congruencia con los principios de derechos humanos y con los instrumentos de planeación vigentes. En este contexto, el Estado impulsa mecanismos de transferencia económica directa como una estrategia para complementar el ingreso de la población en situación de vulnerabilidad y contribuir al mejoramiento de sus condiciones.
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                </h6>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Contribuir a mejorar las condiciones de desarrollo social y bienestar de la población hidalguense conforme al Plan Estatal de Desarrollo 2022-2028, dando prioridad a la población que se encuentra en situación de marginación, pobreza, rezago social o con población indígena, mediante la entrega de apoyos económicos que fortalezcan el desarrollo económico en las 12 regiones del Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Población en pobreza, que habiten en el Estado de Hidalgo, y que tengan de 30 a 64 años de edad al momento de realizar la solicitud de incorporación al programa, dando preferencia a las personas que habiten en las localidades de marginación, pobreza, rezago social, con población indígena o afromexicana en el Estado de Hidalgo, con base en los índices de medición aplicables.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                La cobertura del programa abarca las 12 regiones del Estado de Hidalgo, conforme a la suficiencia presupuestal y financiera.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Ejercicio fiscal 2026
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p>
                  
                <ul>
                <li><b>Subsecretaría de Inclusión y Desarrollo</b></li>
                <dd>Blvd. Felipe Angeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080 Pachuca de Soto, Hgo.</dd>
                </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                Mtro. Juan Roberto Lazcano Trejo
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                7717176000 Ext. 8948
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Horario de atención</h5>
                Lunes a Viernes de 9:30 a 17:00 hrs
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Reglas de Operación</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Estatal_Apoyo_para_el_Bienestar_y_el_Desarrollo_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2026</a>
                </li>
                  </ul>
                
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Convocatoria</h5>
                <ul>
                <li>
                <a
                href='/Convocatorias/BYD'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Marzo 2026</a>
                </li>
                  </ul>


                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Consulta de folios beneficiados</h5>
                <ul>
                  <li>

                <a
                href='https://amigosdelatransformacion.com.mx/byd.php'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Febrero 2024</a>
                </li>
                <li>
                <a
                href='https://amigosdelatransformacion.com.mx/bydoct.php'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Octubre 2024</a>
                </li>
                </ul>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Estadisticas</h5>
                <ul>
                  <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/estadisticas/1erT/Est_ByD_2024_1erT.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Primer Trimestre</a>
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/estadisticas/3erT/Est_ByD_2024_3erT.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Tercer Trimestre</a>
                </li>
                </ul>

        
                

               
                </p>

              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Bienestarydesarrollo;